import { apiOrders } from "@/api"
import { getMerchantId } from "@/lib/company-storage"
import { ExposedCoupon } from "@/types/external/exposed-coupon"
import { useEffect, useState } from "react"

/**
 * Fetches the merchant's coupons exposed to the storefront showcase
 * (`GET /merchants/{id}/coupons/exposed`) for the home carousel.
 *
 * One-shot on mount — no polling. The route is edge-cached for 60s and the
 * exposed set changes rarely, so a fetch-once-per-visit is enough. Fails
 * silently (mirrors `useActiveOrders`): a broken feed just hides the
 * carousel instead of breaking the home page.
 */
export function useExposedCoupons(): ExposedCoupon[] {
  const [coupons, setCoupons] = useState<ExposedCoupon[]>([])

  useEffect(() => {
    const merchantId = getMerchantId()
    if (!merchantId) return

    let cancelled = false

    apiOrders
      .get<ExposedCoupon[]>(`/merchants/${merchantId}/coupons/exposed`)
      .then(({ data }) => {
        if (!cancelled) setCoupons(Array.isArray(data) ? data : [])
      })
      .catch((err) => {
        console.info("[useExposedCoupons] fetch failed (silent)", err)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return coupons
}
